import { useQuery } from 'react-query';
import portoPoliciesServices from './porto-policies.services';
import notificationError from '@/utils/functions/notificationError';
import { AxiosError } from 'axios';
import {
  PortoPolicyBenefitListRequest,
  PortoPolicyVoucherRequest,
} from './porto-policies.types';
import { queryClient } from '@/Root';
import { isAppPortocar } from '@/index';

export const PORTO_POLICIES_LIST_KEY = 'porto/policies/list';
export const PORTO_POLICIES_BENEFITS_LIST_KEY = 'porto/policies/benefits/list';
export const PORTO_POLICIES_VOUCHER_LIST_KEY = 'porto/policies/voucher/list';

export function usePortoPoliciesList(licensePlate?: string, enabled = true) {
  const cache = queryClient.getQueryData([
    PORTO_POLICIES_LIST_KEY,
    { licensePlate },
  ]);

  return useQuery({
    queryKey: [PORTO_POLICIES_LIST_KEY, { licensePlate }],
    queryFn: () => portoPoliciesServices.list(licensePlate),
    onError(err: AxiosError) {
      if (err.response?.status !== 404) {
        notificationError(err, { message: 'Listagem de apolices' });
      }
    },
    enabled: !cache && enabled && licensePlate?.length === 7,
    retry: 0,
  });
}

export function usePortoPolicieBenefitsList(
  parans?: PortoPolicyBenefitListRequest & { complementId?: number },
  enabled = true,
) {
  const queryKey = [PORTO_POLICIES_BENEFITS_LIST_KEY, { ...parans }];

  const cache = queryClient.getQueryData(queryKey);

  return useQuery({
    queryKey,
    queryFn: () => portoPoliciesServices.listBenefit(parans),
    onError(err: AxiosError) {
      if (err.response?.status !== 404) {
        notificationError(err, { message: 'Listagem de apolices' });
      }
    },
    enabled: enabled && !cache,
    retry: 0,
  });
}

export function usePortoPolicieVoucherList(
  params?: PortoPolicyVoucherRequest,
  enabled = true,
) {
  const queryKey = [PORTO_POLICIES_VOUCHER_LIST_KEY, { ...params }];

  const cache = queryClient.getQueryData(queryKey);

  return useQuery({
    queryKey,
    queryFn: () => portoPoliciesServices.listVouncher(params),
    onError(err: AxiosError) {
      if (err.response?.status !== 404) {
        notificationError(err, { message: 'Listagem de voucher' });
      }
    },
    enabled: enabled && !!params?.documentNumber && !cache && isAppPortocar,
    retry: 0,
  });
}
